import apiClient from "../lib/api-client";

export interface SupplierProductPrice {
  id: string;
  supplierId: string;
  productId: string;
  baseUnitPrice: number;
  allowedDeviationPercent: number;
  effectiveDate: string;
  endDate?: string | null;
  isActive: boolean;
  notes?: string | null;
  supplier?: {
    id: string;
    name: string;
    phone?: string;
  };
  product?: {
    id: string;
    name: string;
    sku: string;
    unit: string;
  };
}

export interface UpsertSupplierProductPriceDto {
  supplierId: string;
  productId: string;
  baseUnitPrice: number;
  allowedDeviationPercent?: number;
  effectiveDate?: string;
  endDate?: string;
  notes?: string;
}

export const supplierProductPriceService = {
  async list(params?: {
    supplierId?: string;
    productId?: string;
    activeOnly?: boolean;
  }): Promise<SupplierProductPrice[]> {
    const response = await apiClient.get("/supplier-product-prices", {
      params,
    });
    return response.data;
  },

  async upsert(
    data: UpsertSupplierProductPriceDto,
  ): Promise<SupplierProductPrice> {
    const response = await apiClient.put("/supplier-product-prices", data);
    return response.data;
  },

  async remove(id: string) {
    const response = await apiClient.delete(`/supplier-product-prices/${id}`);
    return response.data;
  },
};
